import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEdit.styl';

import './BXmakerAuthuserphoneEditPhone';
import './BXmakerAuthuserphoneEditSmsCode';
import './BXmakerAuthuserphoneEditUserCall';
import './BXmakerAuthuserphoneEditBotCall';
import './BXmakerAuthuserphoneEditBotSpeech';
import './BXmakerAuthuserphoneEditSimPush';


Vue.component('BXmakerAuthuserphoneEdit', {
    name: 'BXmakerAuthuserphoneEdit',
    data() {
        return {};
    },
    computed: {},
    methods: {
        onInputPhone(value) {
            this.$root.setPhone(value);
        },
        onClickConfirm() {
            this.$root.startConfirm();
        }
    },

    template: `
            <div class="bxmaker-authuserphone-edit" :id="'bxmaker-authuserphone-edit__' + $root.rand" >
                
                <BXmakerAuthuserphoneEmpty v-if="!$root.isAuthorized" >
                 {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_NEED_AUTH}}
                 </BXmakerAuthuserphoneEmpty>                 
               
                    <BXmakerAuthuserphoneEditPhone 
                    v-show="!$root.isShowConfirm && $root.isAuthorized"  
                    :loader="$root.startLoader" 
                    :phone="$root.phone" 
                    :phoneError="$root.phoneError" 
                    @onInputPhone="onInputPhone" 
                    @onClickConfirm="onClickConfirm"                     
                    />   
                    
                    <BXmakerAuthuserphoneEditSmsCode  
                        v-show="$root.isNeedShowConfirmSmsCode"                                    
                    /> 
                    
                    <BXmakerAuthuserphoneEditUserCall  
                        v-show="$root.isNeedShowConfirmUserCall"   
                    /> 
                    
                    <BXmakerAuthuserphoneEditBotCall 
                         v-show="$root.isNeedShowConfirmBotCall"                 
                    />  
                    
                     <BXmakerAuthuserphoneEditBotSpeech
                         v-show="$root.isNeedShowConfirmBotSpeech"                 
                    />  
                      <BXmakerAuthuserphoneEditSimPush
                         v-show="$root.isNeedShowConfirmSimPush"                 
                    />  
                    
                    <div class="bxmaker-authuserphone-edit__change-confirm" v-if="$root.isNeedShowChangeConfirm"  >
                         <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmType" >
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_EDIT_CHANGE_CONFIRM_TYPE}}   
                         </BXmakerAuthuserphoneLink> 
                    </div>   
                
                             
            </div>
        `,
});